(() => {
  const selector = 'wishlist-button-block:not([wk-loaded])';
  const appBarBadgeSelector = '[data-cw-wishlist-count]';
  const headerCounterSelector = '.wishlist-header-link .wkh-counter';
  const searchCardSelector = '#snize_results .snize-product';
  let loaderPromise;
  let scheduled = false;
  let observedCounter;
  let counterObserver;

  const parseCount = (value) => {
    const count = Number.parseInt(String(value || '').replace(/[^0-9]/g, ''), 10);
    return Number.isFinite(count) ? count : 0;
  };

  const syncWishlistCount = () => {
    const source = document.querySelector(headerCounterSelector);
    if (!source) return;

    const count = parseCount(source.textContent);

    document.querySelectorAll(appBarBadgeSelector).forEach((badge) => {
      badge.textContent = String(count);
      badge.hidden = count < 1;

      const link = badge.closest('[data-cw-wishlist-link]');
      const label = link?.dataset.cwWishlistLabel || '';
      if (link && label) link.setAttribute('aria-label', count > 0 ? `${label}: ${count}` : label);
    });
  };

  const observeWishlistCount = () => {
    const counter = document.querySelector(headerCounterSelector);
    if (!counter || counter === observedCounter) {
      syncWishlistCount();
      return;
    }

    counterObserver?.disconnect();
    observedCounter = counter;
    counterObserver = new MutationObserver(syncWishlistCount);
    counterObserver.observe(counter, { childList: true, characterData: true, subtree: true });

    const headerButton = counter.closest('.wkh-button');
    if (headerButton) {
      counterObserver.observe(headerButton, { attributes: true, attributeFilter: ['class'] });
    }

    syncWishlistCount();
  };

  const getLoaderUrl = () => {
    if (window.WishlistKingAppLoaderURL) return window.WishlistKingAppLoaderURL;

    const settingsScript = [...document.scripts].find((script) => (
      script.textContent.includes('WishlistKingAppLoaderURL')
    ));
    const match = settingsScript?.textContent.match(/WishlistKingAppLoaderURL\s*=\s*["']([^"']+)["']/);
    return match?.[1] || '';
  };

  const attachSearchButtons = () => {
    document.querySelectorAll(searchCardSelector).forEach((card) => {
      if (card.querySelector('wishlist-button-block')) return;

      const link = card.querySelector('a.snize-view-link[href]');
      if (!link) return;

      const url = new URL(link.getAttribute('href'), window.location.href);
      const handle = url.pathname.match(/\/products\/([^/]+)\/?$/)?.[1];
      if (url.origin !== window.location.origin || !handle) return;

      const wrapper = document.createElement('div');
      wrapper.className = 'cw-search-wishlist';
      const button = document.createElement('wishlist-button-block');
      button.dataset.productHandle = handle;
      button.setAttribute('align-self', 'center');
      button.setAttribute('align-content', 'center');
      button.setAttribute('show-icon', '');
      wrapper.append(button);
      // Keep the button outside the product link, just like the collection card.
      card.append(wrapper);
    });
  };

  const loadPendingButtons = async () => {
    scheduled = false;
    attachSearchButtons();
    if (!document.querySelector(selector)) return;

    const loaderUrl = getLoaderUrl();
    if (!loaderUrl) return;

    loaderPromise ||= import(loaderUrl);

    try {
      const { default: loader, appSettings } = await loaderPromise;
      await loader.load({
        name: 'wishlist-button-block',
        type: 'lit-component',
        url: appSettings.assets.componentWishlistButtonBlockJs
      });
    } catch {
      loaderPromise = undefined;
    }
  };

  const scheduleLoad = () => {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(loadPendingButtons);
  };

  const start = () => {
    observeWishlistCount();
    scheduleLoad();

    const observer = new MutationObserver((mutations) => {
      const hasWishlistButton = mutations.some(({ addedNodes }) => (
        [...addedNodes].some((node) => (
          node.nodeType === Node.ELEMENT_NODE &&
          (node.matches?.(`${selector}, ${searchCardSelector}`) ||
            node.querySelector?.(`${selector}, ${searchCardSelector}`))
        ))
      ));

      if (hasWishlistButton) scheduleLoad();

      if (!observedCounter?.isConnected || mutations.some(({ addedNodes }) => (
        [...addedNodes].some((node) => (
          node.nodeType === Node.ELEMENT_NODE &&
          (node.matches?.(headerCounterSelector) || node.querySelector?.(headerCounterSelector))
        ))
      ))) {
        observeWishlistCount();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', () => {
      observeWishlistCount();
      scheduleLoad();
    });
    document.documentElement.addEventListener('cart:refresh', scheduleLoad);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
